import { axios } from '@/api/axios.ts';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { TRoom } from '@/services/rooms/rooms.types.ts';

export const roomsApi = {
  getAllRooms: async () => {
    const response = await axios.get<TRoom[]>('rooms');
    return response.data;
  },
};

export const roomsQueries = createQueryKeys('predefinedRooms', {
  getAllRooms: () => ({
    queryKey: ['list'],
    queryFn: () => roomsApi.getAllRooms(),
  }),
});
